/**
 * TODO: 暂时没有好的解决办法
 * 为Store类 中的所有异步方法添加错误处理
 * 原因：在远程模块中，Promise.reject 不会触发 unhandledrejection 事件
 */
export function unhandledrejection<T extends new (...args: any[]) => object>() {
  return function(
    target: T,
    context: ClassDecoratorContext<T>
  ): T {
    if (context.kind !== 'class') {
      return target;
    }

    const { prototype } = target;
    const ownKeys = Object.getOwnPropertyNames(prototype);

    for (const key of ownKeys) {
      if (key === 'constructor') {
        continue;
      }
      const descriptor = Object.getOwnPropertyDescriptor(target.prototype, key);

      // 过滤掉非函数的成员，构造函数和getter/setter，暂时无法处理 private 方法
      if (typeof descriptor?.value !== 'function' || descriptor?.get != null || descriptor?.set != null) {
        continue;
      }

      const originalMethod = descriptor.value;
      // 已包装则跳过
      if ((originalMethod as any).__unhandledWrapped != null) {
        continue;
      }
      const wrappedMethod = function(this: T, ...args: unknown[]): unknown {
        try {
          const result = originalMethod.apply(this, args);
          // 如果返回 Promise，包一层 catch
          if (result != null && typeof result.then === 'function') {
            return result.catch((error: any) => {
              dispatchUnhandledRejection(error);
              throw error;
            });
          }

          return result;
        } catch (error) {
          console.error(`Error in method ${String(key)}:`, error);
          dispatchUnhandledRejection(error);
          // 重新抛出错误，以确保调用者知道发生了错误
          throw error;
        }
      };

      // 方法是否已经被包装过
      (wrappedMethod as any).__isWrapped = true;
      // 替换原有方法
      Object.defineProperty(target.prototype, key, {
        ...descriptor,
        value: wrappedMethod
      });
    }

    return target;
  };
}


const dispatchUnhandledRejection = (error: any): void => {
  console.error('Unhandled error:', error);

  const rejectionEvent = new PromiseRejectionEvent('unhandledrejection', {
    // eslint-disable-next-line promise/no-promise-in-callback
    promise: Promise.reject(error),
    reason: error
  });

  setTimeout(() => {
    window.dispatchEvent(rejectionEvent);
  }, 0);
};

